import {
  getListCredits,getListSubscriptionPrice
} from '@/services/creditsamount';

const getters = {
  listCredits: state => state.listCredits,
  listSubscriptionPrice: state => state.listSubscriptionPrice,
  per_page: state => state.per_page,
};

const actions = {
  async requestListCredits({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = [];
    try {
      const response = await getListCredits({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = response.data!==undefined?response.data:[];
      commit('SET_LIST', returnRes);
      commit('NotificationModule/SET_STATUS', { status: 200, message: ``, errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: err.status, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
  async requestListSubscription({ commit, rootGetters }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    let returnRes = [];
    try {
      const response = await getListSubscriptionPrice({ tokenType: rootGetters['AuthModule/tokenType'], accessToken: rootGetters['AuthModule/accessToken'] });
      returnRes = response.data!==undefined?response.data:[];
      commit('SET_LIST_SUBSCRIPTION', response.data!==undefined?response.data:[]);
      commit('NotificationModule/SET_STATUS', { status: 200, message: ``, errorCode: null }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: err.status, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return returnRes;
  },
};

const mutations = {
  SET_LIST(state, listCredits) {
    state.listCredits = listCredits;
  },
  SET_LIST_SUBSCRIPTION(state, listSubscriptionPrice) {
    state.listSubscriptionPrice = listSubscriptionPrice;
  },
};

export default {
  namespaced: true,
  state: {
    listCredits: [],
    listSubscriptionPrice: [],
    per_page: 50,
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/CreditsAmount/index.js